'use client'

import { Box, Button, Container, Link, Text } from '@doist/marketist'

import { usePathname } from 'next/navigation'

import css from './draft-mode-banner.module.css'

type DraftModeBannerProps = {
    children?: React.ReactNode
    /**
     * Next's cache invalidation is only available on the app router
     * Use this property when displaying the banner within the app router
     */
    appRouter?: boolean
}

export function DraftModeBanner({ children, appRouter = false }: DraftModeBannerProps) {
    const pathname = usePathname()
    const params = new URLSearchParams({ path: pathname ?? '/' })

    return (
        <Box className="box-highlight pb-8">
            <Container>
                <Box className={css.draftInner}>
                    <Text size="body-xs" weight="medium">
                        Draft mode enabled. <Link href={`/nextapi/api/draft-disable`}>Disable</Link>
                    </Text>
                    <Box>
                        {children}
                        {pathname && appRouter ? (
                            <Button
                                variant="tertiary"
                                size="small"
                                href={`/nextapi/api/revalidate?${params.toString()}`}
                            >
                                Update current route
                            </Button>
                        ) : null}
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}
